import { IActionBase, IWhatsappReportsState } from "../models/root.interface";
import { GET_DATA } from "../actions/whatsappReports.action";


const initialState: IWhatsappReportsState = {
    whatsappReportList: [],
    whatsappReportData: {},
};

function whatsappReportsReducer(state: IWhatsappReportsState = initialState, action: IActionBase): IWhatsappReportsState {
    switch (action.type) {
        case GET_DATA: {
            return { ...state, whatsappReportData: action.payload };
        }
        default:
            return state;
    }
}


export default whatsappReportsReducer;